const overview_table = {
	cpu: "CPU cores",
	mem: "RAM geheugen",
	name: "Naam",
	os_name: "Besturingssysteem",
	status: "Status",
};

export default overview_table;
